import { render, staticRenderFns } from "./AlarmOrderCom.vue?vue&type=template&id=6bdb9347&scoped=true"
import script from "./AlarmOrderCom.vue?vue&type=script&lang=js"
export * from "./AlarmOrderCom.vue?vue&type=script&lang=js"
import style0 from "./AlarmOrderCom.vue?vue&type=style&index=0&id=6bdb9347&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdb9347",
  null
  
)

export default component.exports